export default __webpack_public_path__ + "static/media/SZ04.22c2f6b0.mp3";